import { observer } from "mobx-react"

const Faq = observer(() => {
    return (<>
        <section className="faq-section py-5 bg-white" id="faq">
            <h2 className="weird-subtitle text-center mb-4">
                Frequently Asked Questions
            </h2>
            <div className="container">
                <div className="accordion" id="faqAccordion">
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="headingOne">
                            <button
                                className="accordion-button"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseOne"
                                aria-expanded="true"
                                aria-controls="collapseOne"
                            >
                                <span className="faq-icon">❓</span> What is SnowballBoss?
                            </button>
                        </h2>
                        <div
                            id="collapseOne"
                            className="accordion-collapse collapse show"
                            aria-labelledby="headingOne"
                            data-bs-parent="#faqAccordion"
                        >
                            <div className="accordion-body">
                                SnowballBoss is a fun and chaotic memecoin aimed at supporting
                                charitable causes while bringing joy and entertainment to the crypto
                                community.
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="headingTwo">
                            <button
                                className="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseTwo"
                                aria-expanded="false"
                                aria-controls="collapseTwo"
                            >
                                <span className="faq-icon">🔗</span> How can I join the SnowballBoss
                                community?
                            </button>
                        </h2>
                        <div
                            id="collapseTwo"
                            className="accordion-collapse collapse"
                            aria-labelledby="headingTwo"
                            data-bs-parent="#faqAccordion"
                        >
                            <div className="accordion-body">
                                You can join the community by following us on social media platforms
                                like Twitter, Telegram, and Discord, or by buying SNOWBOSS tokens.
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item">
                        <h2 className="accordion-header" id="headingThree">
                            <button
                                className="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseThree"
                                aria-expanded="false"
                                aria-controls="collapseThree"
                            >
                                <span className="faq-icon">💰</span> How can I buy SNOWBOSS tokens?
                            </button>
                        </h2>
                        <div
                            id="collapseThree"
                            className="accordion-collapse collapse"
                            aria-labelledby="headingThree"
                            data-bs-parent="#faqAccordion"
                        >
                            <div className="accordion-body">
                                SNOWBOSS tokens can be purchased through various exchanges or
                                directly from the project's website after launching.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </>)
});

export default Faq;